// For Sticky Navigation and other WhatsApp CTA triggers
document.addEventListener("DOMContentLoaded", function () {
  console.log("WhatsApp CTA script loaded");

  // Determine current page context
  const pathname = window.location.pathname;
  const isProductPage = pathname.includes("/products/");
  const isHomePage = pathname === "/" || pathname === "" || pathname.endsWith("/index.html") || pathname.endsWith("/");

  // Product metadata for PDP messages
  const productTitle = document.querySelector(".m-product-title")?.innerText || document.querySelector("h1")?.innerText || "Product";
  const pageUrl = window.location.href;

  let whatsappMessage = "";

  if (isProductPage) {
    // PDP message
    whatsappMessage = `Hi EverMore Team,

I saw your product on the website:

${productTitle}

${pageUrl}

and I’m interested in it. Could you please provide more details about the product, such as its features, pricing, and availability? I would also like to know if there are any ongoing promotions or discounts for this product.

Thank you!`;
  } else if (isHomePage) {
    // Home page message
    whatsappMessage = `Hello EverMore Store! I'm visiting your website homepage and would like to learn more about your brand and products.`;
  } else {
    // General message for other pages (collections, cart, etc.)
    whatsappMessage = `Hello EverMore Store!

I came from page:
${pageUrl}`;
  }

  // ===== EXCHANGE / RETURN MESSAGE =====
  const returnMessage = `Hi EverMore Team, I want to exchange/return my order.

Order ID:
Reason for Exchange/Return:
Product Name:
Registered Mobile Number:`;

  // Set WhatsApp Links safely with existence checks
  const headerWhatsapp = document.getElementById("whatsapp-header") || document.getElementById("start-chat-link");
  if (headerWhatsapp) {
    headerWhatsapp.href = `https://wa.me/919974900634?text=${encodeURIComponent(whatsappMessage)}`;
  }

  const returnWhatsapp = document.getElementById("return");
  if (returnWhatsapp) {
    returnWhatsapp.href = `https://wa.me/919974900634?text=${encodeURIComponent(returnMessage)}`;
  }

  // Scan all links dynamically to find "Return & Exchange" button in the footer or menu
  const pageLinks = document.querySelectorAll("a");
  pageLinks.forEach(link => {
    const text = link.textContent.toLowerCase();
    const href = link.getAttribute("href") || "";
    
    // Skip policy pages
    if (
      text.includes("policy") || 
      text.includes("policies") || 
      href.toLowerCase().includes("policy") || 
      href.toLowerCase().includes("policies")
    ) {
      return;
    }

    if (
      (text.includes("return") && text.includes("exchange")) || 
      text.includes("return & exchange") || 
      text.includes("returns & exchanges") ||
      (href.toLowerCase().includes("return") && href.toLowerCase().includes("exchange"))
    ) {
      link.href = `https://wa.me/919974900634?text=${encodeURIComponent(returnMessage)}`;
    }
  });
});
